import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import { getTotalQueueCount, getDocUploadCountToday, getBarChartData } from "../../context/actions/dashboard_new";
import './index.scss';
import { Chart } from "react-google-charts";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import Select from 'react-select';
import LoaderUI from "../../components/common/loader";
import CsvModal from "./DashboardHeader/CsvModal/CsvModal";
import FinalCsvModal from "./DashboardHeader/CsvFinalDocModal";
import ReviewModal from "./DashboardHeader/ReviewModal";
import ReviewModalWeekly from "./DashboardHeader/ReviewModalWeekly";
import ChartValueCount from "./ChartValueCount";
import { SocketContext } from '../../context/actions/socket';
import NoItem from "../DocumentDetail/DocumentView/NoItem"
import TimezoneClock from "../../components/common/TimeZone";
import moment from "moment";
// import { logout } from "../../context/actions/user";
// import { useIdleTimer } from 'react-idle-timer';
// import Cookies from 'js-cookie';



const DashboardNew = () => {

	const [organization, setOrganization] = useState();
	const userDetail = useSelector((state) => state?.user?.user?.organization_detail);
	const user = useSelector((state) => state?.user?.user);
	
	// xxxxxxx  AUTO REFRESH IN 10 MINS OF INACTIVITY xxxxxxxx

	const IdleRefreshThreshold = 1000 * 60 * 10; // 10 minutes of inactivity
	// const IdleRefreshThreshold = 10 * 60 ; // 60 seconds of inactivity

	// const idleLogoutThreshold = 1000 * 60 * 15;
	
	const [lastActivity, setLastActivity] = useState(Date.now());
	
	// const handleOnIdle = event => {
	// 	console.log('user is idle', event);
	// 	console.log('last active', getLastActiveTime());
	// 	dispatch(logout(() => {
	// 	}));
	// };
	
	// const { getRemainingTime, getLastActiveTime } = useIdleTimer({
	// 	timeout: idleLogoutThreshold,
	// 	// timeout: 1000 * 60 * 2,
	// 	onIdle: handleOnIdle,
	// });
	
	// useEffect(() => {
	// 	// const lastActive = localStorage.getItem('lastActive');
	// 	const lastActive = Cookies.get('lastActive');
	// 	console.log(lastActive && Date.now() - lastActive ,">", idleLogoutThreshold);		
	// 	if (lastActive && Date.now() - lastActive > idleLogoutThreshold) {
	// 		handleOnIdle();
	// 	}
		
	// }, []);

	
	// useEffect(() => {
	// 	if (!Cookies.get('lastActive')) {
	// 		Cookies.set('lastActive', Date.now());
	// 	}
	// }, [getRemainingTime]);

	useEffect(() => {
		function handleActivity() {
			setLastActivity(Date.now());
		}

		// Add event listeners to detect user activity
		document.addEventListener('mousemove', handleActivity);
		document.addEventListener('keydown', handleActivity);
		document.addEventListener('scroll', handleActivity);

		return () => {
			// Remove event listeners on cleanup
			document.removeEventListener('mousemove', handleActivity);
			document.removeEventListener('keydown', handleActivity);
			document.removeEventListener('scroll', handleActivity);
		};
	}, []);

	useEffect(() => {
		const interval = setInterval(() => {
			const timeSinceLastActivity = Date.now() - lastActivity;
			if (timeSinceLastActivity >= IdleRefreshThreshold) {

				window.location.reload();

				// setBarChartLoading(true);

				// dispatch(getBarChartData({ selectedDataset: selectedDataset, timeFrame: timeFrame }, (res) => {
				// 	// console.log('checking response of docupload', res.editedDocsLastWeek);
				// 	setBarChartLoading(false);
				// 	setDocsEditedLastWeek(res.editedDocsLastWeek);
				// }))

				// setFileQueueLoading(true);
				// setDocumentUploadLoading(true);
				// dispatch(getTotalQueueCount({ prosessStatus: 4 }, (res) => { setTotalQueueCount(res.fileQueueCount); setTotalUsers(res.userCount); setFileQueueLoading(false) }));
				// dispatch(getDocUploadCountToday({}, (res) => {
				// 	setDocUploadCountToday(res.docCount);
				// 	setReviewRequestedToday(res.reviewRequested);
				// 	setReviewRequestedToday2(res.reviewRequested2)
				// 	setReviewRequestedLastWeek(res.reviewRequestedLastWeek);
				// 	setReviewRequestedLastWeek2(res.reviewRequestedLastWeek2);
				// 	setDocUploadLastWeek(res.docUploadLastWeek);
				// 	setDocumentUploadLoading(false);
				// 	setCarryOverDocs(res.carryOverDocs);
				// }))



				// You can add any other logic or actions you want to perform here
			}
		}, 10000); // Check every 30 seconds for user inactivity

		return () => {
			clearInterval(interval); // Clean up the interval when the component unmounts
		};
	}, [lastActivity]);

	// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

	const datasetOptions = [
		{ value: "Uploaded by Org", label: 'All Documents' },
		{ value: 'Uploaded by me', label: 'My Documents' },
	];
	const dataset2Options = [
		{ value: "Weekly", label: 'Past 7 days' },
		{ value: "Monthly", label: 'Current Year (Monthly)' },
		{ value: "Yearly", label: 'Yearly' }
	];

	const { backendSocket, socket } = useContext(SocketContext);

	const dispatch = useDispatch();
	const image = useSelector((state) => state?.user?.logo)
	const [totalQueueCount, setTotalQueueCount] = useState();
	const [totalUsers, setTotalUsers] = useState();
	const [docUploadCountToday, setDocUploadCountToday] = useState();
	const [reviewRequestedLastWeek, setReviewRequestedLastWeek] = useState();
	const [docUploadLastWeek, setDocUploadLastWeek] = useState();
	const [reviewRequestedLastWeek2, setReviewRequestedLastWeek2] = useState();
	const [docsEditedLastWeek, setDocsEditedLastWeek] = useState();
	let [fileQueueLoading, setFileQueueLoading] = useState(true);
	let [documentUploadLoading, setDocumentUploadLoading] = useState(true);
	let [barChartLoading, setBarChartLoading] = useState(true);
	let [carriedOverDocs, setCarryOverDocs] = useState();
	const [showModel, setShowModel] = useState(false);
	const [showFinalDocModel, setShowFinalDocModel] = useState(false);
	const [barRange, setBarRange] = useState();
	const [selectedDataset, setSelectedDataset] = useState(datasetOptions[0].value);
	const [timeFrame, setTimeFrame] = useState(dataset2Options[0].value);
	const [lastRefreshTime, setLastRefreshTime] = useState('');

	const getPastWorkingDates = () => {
		const currentDate = new Date();
		const pastWorkingDates = [];

		// Helper function to check if a given date is a weekend (Saturday or Sunday)
		const isWeekend = (date) => {
			const dayOfWeek = date.getDay();
			return dayOfWeek === 0 || dayOfWeek === 6;
		};

		const formatDate = (date) => {
			const day = date.getDate();
			const month = date.toLocaleString('default', { month: 'long' });
			const year = date.getFullYear();
			return `${day} ${month} ${year}`;
		};

		let count = 0;
		while (count < 7) {
			// Check if the current date is a weekend, if not, add it to the pastWorkingDates array
			if (!isWeekend(currentDate)) {
				pastWorkingDates.unshift(formatDate(currentDate)); // Add the formatted date to the beginning of the array
				count++;
			}
			currentDate.setDate(currentDate.getDate() - 1); // Move to the previous day
		}

		return pastWorkingDates;
	};
	const workingDays = getPastWorkingDates();
	// console.log('workingDays =>', workingDays)






	// Get today's date
	const today = new Date();
	const todayString = today.toISOString().slice(0, 10).replace(/-/g, '');

	// Generate an array of all dates in the last week
	const lastWeekDates = [];
	const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
	const daysToShow = 9; // Number of weekdays to show (excluding weekends)
	for (let i = 0; i < daysToShow; i++) {
		const currentDate = new Date(today.getTime() - i * oneDay);
		// Check if the current date is a Saturday (dayOfWeek: 6) or Sunday (dayOfWeek: 0)
		const dayOfWeek = currentDate.getDay();
		// if (i == 0) console.log('dayOfWeek start =>')
		// console.log('dayOfWeek', currentDate);
		if (dayOfWeek !== 6 && dayOfWeek !== 0) {
			const dateString = currentDate.toISOString().slice(0, 10).replace(/-/g, '');
			lastWeekDates.push(dateString);
		}
	}

	// console.log('lastWeekDates', lastWeekDates)


	const handleDateFormat = (value) => {
		const dateString = value;
		const year = dateString?.slice(0, 4);
		const month = dateString?.slice(4, 6) - 1;
		// console.log('sadasdsadsadsa', dateString?.length);
		let formattedDate = "";
		if (dateString?.length > 7) {
			const day = dateString?.slice(6, 8);

			const monthNames = [
				"January", "February", "March", "April", "May", "June",
				"July", "August", "September", "October", "November", "December"
			];
			formattedDate = `${parseInt(day)} ${monthNames[month]} ${year}`;
			// const date = new Date(year, month, day);
			// const options = { year: 'numeric', month: 'long', day: 'numeric' };
			// formattedDate = date.toLocaleDateString(undefined, options);
		}
		else if (dateString?.length < 5) {
			const date = new Date(year);
			const options = { year: 'numeric' };
			formattedDate = date.toLocaleDateString(undefined, options);
		}
		else {
			const date = new Date(year, month);
			const options = { year: 'numeric', month: 'long' };
			formattedDate = date.toLocaleDateString(undefined, options);

		}

		// const day= '5';
		return formattedDate;
	};



	// console.log('docsEditedLastWeek', docsEditedLastWeek)

	// const chartData = [
	// 	["Date", "Count"], // Column headers
	// 	...(docsEditedLastWeek ?? []).map((item) => [handleDateFormat(item.date), item.editedDocs]), // Data rows
	// ];


	let chartData = (docsEditedLastWeek ?? []).map((item) => ({
		date: handleDateFormat(item._id),
		count: item.totalValidation,
	}));



	// console.log('chartData =>123', chartData)

	// chartData.map((item) => {
	// 	chartData.push({date: handleDateFormat(item.date), count: item.count })
	// })

	// if (timeFrame == "Weekly") {
	// 	lastWeekDates.forEach((date) => {
	// 		const existingData = chartData.find((item) => item.date === handleDateFormat(date));
	// 		if (!existingData) {
	// 			chartData.push({ date: handleDateFormat(date), count: 0 });
	// 		}
	// 	});
	// }

	// console.log('chartData =>456', chartData);

	// to remove weekend days from chartData and to add days since the last 7 working days for which there was no data from the backend
	if (timeFrame == "Weekly") {
		workingDays.forEach((date) => {
			const existingData = chartData.find((item) =>
				item.date == date
			);
			if (!existingData) {
				chartData.push({ date: date, count: 0 });
			}
		})

		chartData = chartData.filter((item) => workingDays.includes(item.date));
	}

	const totalEditedDocsLastWeek = chartData?.reduce((sum, item) => {
		return sum + item.count;
	}, 0);

	chartData.sort((a, b) => new Date(a.date) - new Date(b.date));


	const formatDate = (dateString) => {
		if (timeFrame == "Weekly") {
			const date = new Date(dateString);
			const day = date.getDate();
			const month = date.toLocaleString('default', { month: 'long' });
			return `${day} ${month}`;
		}
		else if (timeFrame == "Monthly") {
			const [monthString, yearString] = dateString.split(' ');
			const monthIndex = new Date(Date.parse(`${monthString} 1, 2000`)).getMonth();
			const year = parseInt(yearString);
			const date = new Date(year, monthIndex);
			const month = date.toLocaleString('default', { month: 'long' });
			return `${month}`;
		}
		else {
			const date = new Date(dateString);
			const year = date.getFullYear();
			return `${year}`
		}
	};

	const formatTick = (value) => {
		// Display only whole numbers
		return Number.isInteger(value) ? value : '';
	};




	const [reviewRequestedToday, setReviewRequestedToday] = useState();
	const [reviewRequestedToday2, setReviewRequestedToday2] = useState([]);
	const [reviewRange, setReviewRange] = useState();

	const userRole = useSelector((state) => state?.user?.user?.role)
	// console.log('user detail', userRole)

	// **************  block for getting refresh time *********************


	const getCurrentTimestamp = () => {
		return new Date().toLocaleString();
	};

	const updateLastRefreshTime = () => {
		const currentTime = getCurrentTimestamp();
		setLastRefreshTime(currentTime);
		localStorage.setItem('lastRefreshTime 123', currentTime);
	};

	useEffect(() => {
		const storedRefreshTime = localStorage.getItem('lastRefreshTime');
		if (storedRefreshTime) {
			setLastRefreshTime(storedRefreshTime);
		} else {
			updateLastRefreshTime();
		}

		window.addEventListener('beforeunload', updateLastRefreshTime);

		return () => {
			window.removeEventListener('beforeunload', updateLastRefreshTime);
		};
	}, []);

	// *********************  block end  ***********************

	const copyEmailToClipboardFallback = () => {
		const email = 'MORiSupport@gettrained.ai';

		const input = document.createElement('input');
		input.value = email;
		document.body.appendChild(input);
		input.select();
		document.execCommand('copy');
		document.body.removeChild(input);

		toast.success('Email copied to clipboard!');
	};

	const copyEmailToClipboard = async () => {
		if (navigator.clipboard) {
			try {
				await navigator.clipboard.writeText('MORiSupport@gettrained.ai');
				toast.success('Email copied to clipboard!');
			} catch (error) {
				console.error('Clipboard copy failed:', error);
				copyEmailToClipboardFallback(); // Fallback to traditional method
			}
		} else {
			copyEmailToClipboardFallback(); // Fallback to traditional method
		}
	};
	const show = () => {
		setShowModel(true);
	};
	const closeModal = () => {
		setShowModel(false);
	};

	const showFinalDocModal = () => {
		setShowFinalDocModel(true);
	};

	const closeFinalDocModal = () => {
		setShowFinalDocModel(false);
	};

	const [modalOpen, setModalOpen] = useState(false);
	const [modalOpen1, setModalOpen1] = useState(false);

	const handleDatasetChange = (selectedOption) => {
		setSelectedDataset(selectedOption.value);
		setBarChartLoading(true);
		dispatch(getBarChartData({ selectedDataset: selectedOption.value, timeFrame: timeFrame }, (res) => {
			setBarChartLoading(false);
			setDocsEditedLastWeek(res.editedDocsLastWeek);
		}))
	};

	// console.log('selectedDataset safdsad', selectedDataset)

	const handleDatasetChange2 = (selectedOption) => {
		setBarChartLoading(true);
		setTimeFrame(selectedOption.value);
		dispatch(getBarChartData({ selectedDataset: selectedDataset, timeFrame: selectedOption.value }, (res) => {
			setBarChartLoading(false);
			setDocsEditedLastWeek(res.editedDocsLastWeek);
		}))
	};

	const getSelectedDataset = () => {
		// console.log(selectedDataset, 'getSelectedDataset')
		return chartData;
	};

	const toggleModal = (range) => {
		if (reviewRequestedToday > 0) {
			setModalOpen(!modalOpen);
		}
	};

	const toggleModal1 = (range) => {
		if (reviewRequestedLastWeek > 0) {
			setModalOpen1(!modalOpen1);
		}
	};

	reviewRequestedToday2 && reviewRequestedToday2.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
	reviewRequestedLastWeek2 && reviewRequestedLastWeek2.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));


	useEffect(() => {
		setOrganization(userDetail?.name)
		// console.log('organisation', userDetail)
	}, [userDetail])

	useEffect(() => {
		setFileQueueLoading(true);
		setDocumentUploadLoading(true);
		dispatch(getTotalQueueCount({ prosessStatus: 4 }, (res) => { setTotalQueueCount(res.fileQueueCount); setTotalUsers(res.userCount); setFileQueueLoading(false) }));
		dispatch(getDocUploadCountToday({}, (res) => {
			setDocUploadCountToday(res.docCount);
			setReviewRequestedToday(res.reviewRequested);
			setReviewRequestedToday2(res.reviewRequested2)
			setReviewRequestedLastWeek(res.reviewRequestedLastWeek);
			setReviewRequestedLastWeek2(res.reviewRequestedLastWeek2);
			setDocUploadLastWeek(res.docUploadLastWeek);
			setDocumentUploadLoading(false);
			setCarryOverDocs(res.carryOverDocs);
		}))
	}, [])

	useEffect(() => {
		setBarChartLoading(true);
		// console.log('sadsagdjasdsghafagf', selectedDataset, '=>', timeFrame)
		dispatch(getBarChartData({ selectedDataset: selectedDataset, timeFrame: timeFrame }, (res) => {
			// console.log('checking response of docupload', res.editedDocsLastWeek);
			setBarChartLoading(false);
			setDocsEditedLastWeek(res.editedDocsLastWeek);
		}))
	}, [])



	useEffect(() => {
		console.log('useEffect hitting desired')
		backendSocket.off("orgUserDeleted").on("orgUserDeleted", (res, err) => {
			if (res) {
				console.log('data abc data data', res.data, userDetail._id)
				if (res && res?.data?.organization == userDetail._id) {
					if (res.data.deleted == false) {
						setTotalUsers((prevTotalUsers) => prevTotalUsers + 1);
					} else if (res.data.deleted == true) {
						setTotalUsers((prevTotalUsers) => prevTotalUsers - 1);
					}
				}
			}
		});
		backendSocket.off('fileQueueDeleted').on('fileQueueDeleted', (res, err) => {
			if (res) {
				console.log('sdaasdacasfwg', res.data)
				if (res && res.data?.organization == userDetail._id) {
					if (res.data?.status <= 4) {
						setTotalQueueCount((prevTotalQueueCount) => prevTotalQueueCount - 1);
					}
				}
			}
		})
		// console.log('org id of user =>', userDetail?._id)
		socket.off(`file-in-queue-${userDetail?._id}`).on(`file-in-queue-${userDetail?._id}`, (res, err) => {
			if (res) {
				// console.log('socket kafka res', res.data)
				setTotalQueueCount((prevTotalQueueCount) => prevTotalQueueCount + 1);
			}
			if (err) {
				// console.log('err =>', err)
			}
		})
		socket.off(`file-in-queue-done-${userDetail?._id}`).on(`file-in-queue-done-${userDetail?._id}`, (res, err) => {
			if (res) {
				// console.log('socket kafka res 123', res.data)
				setTotalQueueCount((prevTotalQueueCount) => prevTotalQueueCount - 1);
			}
			if (err) {
				// console.log('err =>', err)
			}
		})
	}, []);

	// console.log('sadasdasdsdasd', chartData)


	return (
		<>
			<CsvModal showModel={showModel} closeModal={closeModal} />
			<FinalCsvModal showModel={showFinalDocModel} closeModal={closeFinalDocModal} />
			<ReviewModal modalOpen={modalOpen} toggleModal={toggleModal} reviewRequestedToday2={reviewRequestedToday2}></ReviewModal>
			<ReviewModalWeekly modalOpen={modalOpen1} toggleModal={toggleModal1} reviewRequestedLastWeek2={reviewRequestedLastWeek2}></ReviewModalWeekly>
			<div className="dashboard-new-wrapper d-flex flex-column flex-fill overflow-auto">
				<section className="header-section d-flex overflow-auto">
					<div className="d-flex align-items-center">
						{image && <img src={image} alt="" width="100" height="75" style={{ marginLeft: "15px" }} />}
					</div>
					<div className="col-block file-block d-flex align-items-center flex-fill">

						<div className="left-col">
							<h2 className="title">{organization} / Dashboard</h2>
						</div>
						<div className="right-col flex-fill d-flex align-items-center">
							{fileQueueLoading ? <LoaderUI FullWindow={false} /> :
								<>
									<div className="files-info">
										<h3>File Queue:<span>{totalQueueCount} {totalQueueCount?.length == 1 ? 'file' : 'files'} in process</span></h3>
										{/* {userRole == "business" ? */}
										<h3>User Total:<span>{totalUsers}</span></h3>
										{/* : null */}
										{/* } */}
									</div>
									<div className="refresh-info text-center ms-auto">
										<Button onClick={() => { window.location.reload() }} color="link">Refresh Dashboard</Button>
										<p>
											Last Refresh:
											<span className="d-block">
												{(lastRefreshTime && user?.timezone)? <TimezoneClock timezone={user.timezone} dateTime={lastRefreshTime.toLocaleDateString} timeFormat={"MM/DD/YYYY, h:mm A"}/>:  moment(lastRefreshTime).format("MM/DD/YYYY, h:mm A")}
											</span>
										</p>
									</div>
								</>
							}
						</div>
					</div>
					<div className="col-block support-block d-flex align-items-center flex-fill">
						<div className="left-col">
							<div className="logo-cell d-inline-flex align-items-center">
								<img className="img-fluid" src={require('../../assets/img/Main_Logo.png')} alt="Logo" />
								<span className="txt">
									Support
								</span>
							</div>
						</div>
						<div className="right-col d-flex align-items-center text-center">
							<div className="office-hrs">
								<p>
									Office Hours: M -F
									<span className="d-block">
										8AM to 5PM EST
									</span>
								</p>
								<a href="mailto:MORiSupport@gettrained.ai">
									MORiSupport@gettrained.ai
								</a>
							</div>
							<div className="call-info">
								<p>
									Call Us:
									<span className="d-block">
										833-888-0103
									</span>
								</p>
								<Button color="link" onClick={copyEmailToClipboard}>Copy Email</Button>
							</div>
						</div>
					</div>
					<div className="col-block btns-cell d-inline-flex align-items-center">
						<Button
							color="secondary"
							onClick={() => show()}
							className="report-btn"
							style={{margin: "10px"}}
						>
							<span className="d-inline-flex align-items-center">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="11.999"
									height="15.367"
									viewBox="0 0 11.999 15.367"
								>
									<path
										id="file"
										d="M68,3.331c0-.006,0-.011,0-.016V3.309c0-.006,0-.013,0-.019v0l-.007-.019v0l-.008-.017v0l-.009-.015,0,0-.01-.013,0,0-.014-.015h0L64.805.066l0,0L64.789.051l-.005,0L64.771.038l0,0L64.752.027l0,0L64.732.017h0L64.712.01h0L64.69,0h-.006l-.016,0H57.188A1.189,1.189,0,0,0,56,1.188V14.179a1.189,1.189,0,0,0,1.188,1.188h9.623A1.189,1.189,0,0,0,68,14.179V3.353Q68,3.342,68,3.331ZM64.871.77l2.358,2.358H65.608a.738.738,0,0,1-.737-.737Zm1.94,14.146H57.188a.738.738,0,0,1-.737-.737V1.188a.738.738,0,0,1,.737-.737H64.42v1.94a1.189,1.189,0,0,0,1.188,1.188h1.94v10.6A.738.738,0,0,1,66.811,14.916Z"
										transform="translate(-56)"
									/>
								</svg>
							</span> 
							GENERATE CSV
						</Button>
						<Button
							color="secondary"
							onClick={() => showFinalDocModal()}
							className="report-btn"
							style={{margin: "10px"}}
						>
							<span className="d-inline-flex align-items-center">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="11.999"
									height="15.367"
									viewBox="0 0 11.999 15.367"
								>
									<path
										id="file"
										d="M68,3.331c0-.006,0-.011,0-.016V3.309c0-.006,0-.013,0-.019v0l-.007-.019v0l-.008-.017v0l-.009-.015,0,0-.01-.013,0,0-.014-.015h0L64.805.066l0,0L64.789.051l-.005,0L64.771.038l0,0L64.752.027l0,0L64.732.017h0L64.712.01h0L64.69,0h-.006l-.016,0H57.188A1.189,1.189,0,0,0,56,1.188V14.179a1.189,1.189,0,0,0,1.188,1.188h9.623A1.189,1.189,0,0,0,68,14.179V3.353Q68,3.342,68,3.331ZM64.871.77l2.358,2.358H65.608a.738.738,0,0,1-.737-.737Zm1.94,14.146H57.188a.738.738,0,0,1-.737-.737V1.188a.738.738,0,0,1,.737-.737H64.42v1.94a1.189,1.189,0,0,0,1.188,1.188h1.94v10.6A.738.738,0,0,1,66.811,14.916Z"
										transform="translate(-56)"
									/>
								</svg>
							</span>
							GENERATE FINAL DOC CSV
						</Button>
					</div>
				</section>
				<section className="inner-section-wrapper d-flex flex-column flex-fill overflow-auto">
					<div className="document-info-row d-flex flex-fill overflow-auto">
						<div className="left-col d-flex flex-column">
							<div className="upload-doc-breakdown flex-fill">
								<h2>Document Upload Breakdown:</h2>
								{documentUploadLoading ? <LoaderUI FullWindow={false} /> :
									<div className="inner">
										<div className="breakdown-row">
											<h3>Today</h3>
											<ul className="item-list">
												<li className="item d-flex align-items-center">
													<span>Documents Uploaded</span>
													<label className="ms-auto">{docUploadCountToday}</label>
												</li>
												<li className="item d-flex align-items-center">
													<span>Review Requested</span>
													<label className="ms-auto">
														<Button onClick={toggleModal} color="link" className="p-0">
															{reviewRequestedToday}
														</Button>
													</label>
												</li>
												<li className="item d-flex align-items-center">
													<span>Carried from Yesterday</span>
													<label className="ms-auto">
														{carriedOverDocs}
													</label>
												</li>
											</ul>
										</div>
										<div className="breakdown-row">
											<h3>Past 7 days</h3>
											<ul className="item-list">
												<li className="item d-flex align-items-center">
													<span>Review Requested</span>
													{/* <label className="ms-auto">{reviewRequestedLastWeek}</label> */}
													<label className="ms-auto">
														<Button onClick={toggleModal1} color="link" className="p-0">
															{reviewRequestedLastWeek}
														</Button>
													</label>
												</li>
												<li className="item d-flex align-items-center total">
													<span>Total </span>
													<label className="ms-auto">
														<label className="ms-auto">
															{docUploadLastWeek - docUploadCountToday}
														</label>
													</label>
												</li>

											</ul>
										</div>
									</div>
								}
							</div>
						</div>
						<div className="mid-col">
							{barChartLoading ? <LoaderUI FullWindow={false} /> : !chartData.length ? <NoItem /> :
								<ul className="upload-file-time">
									{chartData?.map((item, key) => {
										return (
											<li className="d-flex align-items-center">
												<span>{item?.date}</span>
												<label className="ms-auto">{item?.count}</label>
											</li>)
									})}
									<li className="d-flex align-items-center total position-sticky">
										<span>Total</span>
										<label className="ms-auto">{totalEditedDocsLastWeek}</label>
									</li>
								</ul>
							}

						</div>
						<div className="right-col flex-fill">
							<div className="document-review-wrapper">
								<div className="total-doc-rw text-center">
									<div className="total-doc d-inline-block text-center">
										Total Documents Analyzed
										<div style={{ display: "flex", marginTop: '10px' }}>
											<Select
												className='dropdown'
												style={{ flex: 1 }}
												placeholder="All Documents"
												options={datasetOptions}
												value={selectedDataset.value}
												onChange={(e) => { handleDatasetChange(e) }}
											/>
											<Select
												className='dropdown'
												style={{ flex: 1 }}
												placeholder="Past 7 days"
												options={dataset2Options}
												value={timeFrame.value}
												onChange={(e) => { handleDatasetChange2(e) }}
											/>
										</div>
									</div>
									<div className="row-section">
										{barChartLoading ? <LoaderUI FullWindow={false} /> :
											<div>
												{!chartData.length ? <NoItem /> : chartData.length == 1 ? <ChartValueCount data={chartData} />
													: < ResponsiveContainer width="100%" height={245}>
														<BarChart
															margin={{ bottom: 10 }}
															data={getSelectedDataset()}>
															<XAxis dataKey="date" tickFormatter={formatDate} label={{ value: 'Date', position: 'insideTop', angle: 0, offset: 28, style: { fontWeight: 'bold' } }} />
															<YAxis tickFormatter={formatTick} label={{ value: '# of Docs Analyzed', angle: -90, position: 'insideLeftMiddle', dx: -15, style: { fontWeight: 'bold' } }} />
															<Tooltip />
															<Bar dataKey="count" fill="#FB80A8" />
														</BarChart>
													</ResponsiveContainer>
												}
											</div>
										}
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div >
		</>
	);

}
export default DashboardNew;